// Vendor imports
const _ = require('lodash')

// eslint-disable-next-line complexity
module.exports = function (pbGlobals) {
  const { ShareType, StreamType } = pbGlobals
  const { PageType } = pbGlobals.PageContext

  function convertPageContext(pageContext) {
    const result = {
      page: convertPageNameToPageType(pageContext['page_name']),
      pageSection: pageContext['page_section'],
      recId: pageContext['rec_id'],
      recBatchId: pageContext['rec_batch_id'],
      streamType: convertStreamType(pageContext['stream_type'])
    }
    switch (result.streamType) {
      case StreamType.USER_MIXED_STREAM:
        result.userId = pageContext['stream_id']
        break
      case StreamType.MIX_STREAM:
        result.mixId = pageContext['stream_id']
        break
      case StreamType.CATEGORY_STREAM:
        result.categorySlugKey = pageContext['stream_key']
        break
      case StreamType.TOPIC_STREAM:
        result.topicKey = pageContext['stream_key']
        break
      case StreamType.SEARCH_POSTS_STREAM:
      case StreamType.SEARCH_COLLECTIONS_STREAM:
      case StreamType.SEARCH_INTERESTS_STREAM:
      case StreamType.SEARCH_PEOPLE_STREAM:
      case StreamType.SEARCH_ALL_STREAM:
        result.searchQuery = pageContext['stream_key']
        break
    }
    return result
  }

  /**
   * @param {string|number} pageName
   * @returns {number}
   */
  function convertPageNameToPageType(pageName) {
    switch (pageName) {
      case 'feed.list':
        return PageType.STREAMS_PAGE
      case 'inbox.sent':
        return PageType.INBOX_SENT
      case 'inbox.received':
        return PageType.INBOX_RECEIVED
      case 'article.card':
        return PageType.CARD_VIEW
      case 'article.webview':
        return PageType.CONTENT_VIEW
      case 'share.dialog':
        return PageType.IN_APP_SHARE
      case 'extension.share':
        return PageType.SHARE_EXTENSION
      case 'share.extension.mix.add':
        return PageType.SHARE_EXTENSION_MIXED_BY
      case 'user.pages':
      case 'user.posts':
        return PageType.USER_PROFILE_PAGES
      case 'user.followers':
        return PageType.USER_PROFILE_FOLLOWERS
      case 'user.following':
        return PageType.USER_PROFILE_FOLLOWING
      case 'user.seen':
        return PageType.USER_PROFILE_SEEN
      case 'mix.posts':
      case 'mix.pages':
        return PageType.MIX_PROFILE_PAGES
      case 'mix.followers':
        return PageType.MIX_PROFILE_FOLLOWERS
      case 'topic.posts':
      case 'topic.pages':
        return PageType.TOPIC_PROFILE_PAGES
      case 'topic.followers':
        return PageType.TOPIC_PROFILE_FOLLOWERS
      case 'setup.topics':
        return PageType.ONBOARDING_CATEGORY_FOLLOW
      case 'setup.follows':
      case 'setup.friends':
      case 'setup-v2.friends':
        return PageType.ONBOARDING_USER_FOLLOW
      case 'share.thread':
        return PageType.SHARE_CONVERSATION
      case 'feed.end':
        return PageType.END_OF_STREAM
      case 'deeplink':
        return PageType.DEEP_LINK
      case 'search':
        return PageType.SEARCH_PAGE
      case 'setup.collections':
      case 'setup-v2.collections':
        return PageType.ONBOARDING_MIX_FOLLOW
      case 'setup.interests':
      case 'onboarding.interests':
        return PageType.ONBOARDING_INTEREST_FOLLOW
      case 'find.friends':
        return PageType.FIND_FRIENDS
      case 'setup.show':
      case 'setup.profile':
      case 'setup-v2.profile':
        return PageType.ONBOARDING_PROFILE
      case 'stream.profile':
        return PageType.STREAM_PROFILE_PAGE
      case 'user.mixes':
      case 'user.collections':
      case 'user.collections.created':
        return PageType.USER_PROFILE_CREATED_COLLECTIONS
      case 'user.followingMixes':
      case 'user.collections.subscribed':
        return PageType.USER_PROFILE_SUBSCRIBED_COLLECTIONS
      default:
        return PageType[pageName] || PageType.UNKNOWN_PAGE
    }
  }

  /**
   * @param {string|number} shareType
   * @returns {number}
   */
  function convertShareType(shareType) {
    const shareTypeKey = _.snakeCase(shareType).toUpperCase()
    for (let key of [ shareTypeKey, `${shareTypeKey}_SHARE` ]) {
      if (ShareType[key] != null) {
        return ShareType[key]
      }
    }
    switch (shareTypeKey) {
      case 'FACEBOOK':
        return ShareType.FB_SHARE
      case 'GENERAL':
      case 'COPY':
        return ShareType.EXTERNAL_SHARE
      default:
        return ShareType.UNKNOWN_SHARE_TYPE
    }
  }

  /**
   * @param {string|number} streamType
   * @returns {number}
   */
  function convertStreamType(streamType) {
    const streamTypeKey = _.snakeCase(streamType).toUpperCase()
    for (let key of [ streamTypeKey, `${streamTypeKey}_STREAM` ]) {
      if (StreamType[key] != null) {
        return StreamType[key]
      }
    }
    switch (streamTypeKey) {
      case 'SEARCH_MIXES':
        return StreamType.SEARCH_COLLECTIONS_STREAM
      case 'SEARCH':
        return StreamType.SEARCH_ALL_STREAM
      default:
        return StreamType.UNKNOWN_STREAM_TYPE
    }
  }

  return {
    convertPageContext,
    convertPageNameToPageType,
    convertShareType,
    convertStreamType
  }
}
